// extracted by mini-css-extract-plugin
module.exports = {"content":"InvoiceModal_content__1VowX"};